<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="Voucher List" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <div class="voucher_hd">
      <ul>
        <li :class="{ active: activeStore === 1 }"><a href="#" @click.prevent="setactiveStore(1)">Kitchen Appliances</a></li>
        <li :class="{ active: activeStore === 2 }"><a href="#" @click.prevent="setactiveStore(2)">Cookware</a></li>
        <li :class="{ active: activeStore === 5 }"><a href="#" @click.prevent="setactiveStore(5)">Flatware</a></li>
        <li :class="{ active: activeStore === 18 }"><a href="#" @click.prevent="setactiveStore(18)">Kitchen Tools</a></li>
        <li :class="{ active: activeStore === 19 }"><a href="#" @click.prevent="setactiveStore(19)">Kitchen Knife</a></li>
      </ul>
    </div>

    <div class="common-popup-content">
      <template v-if="filteredVouchers.length > 0">
        <div v-for="(voucher, index) in filteredVouchers">
            <div class="voucher_item" @click="receiveVoucher(voucher.vouchertemplate_id, index)" v-if="voucher.is_have == 0">
              <div class="voucher_bd voucher_bd02">
                <div class="par">
                  <div class="top">
                    <sub class="sign">$</sub>
                    <span>{{ voucher.vouchertemplate_price }}</span>
                  </div>
                  <p>Order Over ${{ voucher.vouchertemplate_limit }}</p>
                </div>
                <div class="copy">
                  Deadline：
                  <p>{{ voucher.vouchertemplate_enddate_text }}</p>
                  <a href="javascript:void(0);" v-if="voucher.is_have == 0">Get</a>
                  <a href="javascript:void(0);" v-else>Use now</a>
                </div>
                <i></i>
              </div>
            </div>

            <div class="voucher_item" @click="jumpUrl(voucher.vouchertemplate_store_id)" v-else>
              <div class="voucher_bd voucher_bd02">
                <div class="par">
                  <div class="top">
                    <sub class="sign">$</sub>
                    <span>{{ voucher.vouchertemplate_price }}</span>
                  </div>
                  <p>Order Over ${{ voucher.vouchertemplate_limit }}</p>
                </div>
                <div class="copy">
                  Deadline：
                  <p>{{ voucher.vouchertemplate_enddate_text }}</p>
                  <a href="javascript:void(0);" v-if="voucher.is_have == 0">Get</a>
                  <a href="javascript:void(0);" v-else>Use now</a>
                </div>
                <i></i>
              </div>
            </div>
        </div>
      </template>
      <template v-else><div class="voucher_item" style="text-align: center;padding: 20px 0;">No data</div></template>

    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import { getVoucherList, receiveVoucher } from '../../../api/homestoredetail'
export default {
  name: 'Voucherlist',
  data () {
    return {
      activeStore: 1,
      categories: [
        'All Vouchers',
        'Kitchen Appliances',
        'Cookware',
        'Cutlery',
        'Kitchen Tools'
      ],
      vouchers: [],
      filteredVouchers: []
    }
  },
  components: {

  },
  computed: {
    // filteredVouchers () {
    //   return this.vouchers.filter(voucher => voucher.vouchertemplate_store_id === this.activeStore)
    // },
    ...mapState({
      user: state => state.member.info
    })
  },
  created () {
    var userId = 0
    if (this.user) {
      userId = this.user.member_id
    }
    getVoucherList(userId).then((res) => {
      this.vouchers = res.result.voucher_list

      this.filteredVouchers = this.vouchers.filter(voucher => voucher.vouchertemplate_store_id === this.activeStore)
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  methods: {
    receiveVoucher (tid, index) {
      let that = this
      receiveVoucher(
        tid
      ).then((res) => {
        Toast(res.message)
        that.filteredVouchers[index].is_have = 1
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    jumpUrl (storeid) {
      this.$router.push({ 'name': 'HomeStoreGoodslist', 'query': { id: storeid } })
    },
    setactiveStore (index) {
      this.activeStore = index
      this.filteredVouchers = this.vouchers.filter(voucher => voucher.vouchertemplate_store_id === this.activeStore)
    }
  }
}
</script>

<style scoped>
  .voucher_hd{
    position: fixed;
    height: 2.2rem;
    width: 100%;
    top: 2rem;
    z-index: 100;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* 平滑滚动(iOS) */
    scrollbar-width: none; /* 隐藏滚动条(Firefox) */
  }
  .voucher_hd::-webkit-scrollbar {
    display: none; /* 隐藏滚动条(Chrome, Safari) */
  }
  .voucher_hd ul{
    display: flex;
    list-style: none;
    min-width: min-content;
    /*display: flex;
    justify-content: space-around;
    align-content: center;
    align-items: center;*/
    height: 100%;
    background: rgba(255, 255, 255, 1);
    border-bottom: 1px solid #e8eaed;
  }
  .voucher_hd ul li{
    flex: 0 0;
    font-size: 0.7rem;
    color: rgba(124, 127, 136, 1);
    height: 100%;
    text-align: center;
    line-height: 2.2rem;
    border-bottom: 0.1rem solid transparent;
    margin: 0 0.5rem;
    box-sizing:border-box;
  }
  .voucher_hd ul li.active {
    color: #E93B3DFF;
    border-bottom-color: #E93B3DFF;
  }
  .voucher_hd ul li a{
    color: #333;
    display: block;
    text-decoration: none;
    transition: all 0.3s ease;
    white-space: nowrap;
    padding: 0 0.5rem;
  }
  .common-popup-content{
    overflow-y:auto;
    position:absolute;
    top:4.2rem;
    bottom:0;
    width:100%;
    background:#fff;
  }
  .voucher_bd {
    width: 17.7rem;
    height:5.5rem;
    padding: 0 0.4rem;
    position: relative;
    overflow: hidden;
    margin: 0.8rem auto;
  }
  .voucher_bd:before {
    content: '';
    position: absolute;
    top:0;
    bottom:0;
    left:0.4rem;
    right:0.4rem;
    z-index: -1;
  }
  .voucher_bd:after {
    content: '';
    position: absolute;
    left:0.4rem;
    top:0.4rem;
    right:0.4rem;
    bottom:0.4rem;
    box-shadow: 0 0 1rem 1px rgba(0, 0, 0, 0.5);
    z-index: -2;
  }
  .voucher_bd i{
    position: absolute;
    left: 20%;
    top:2.25rem;
    height:9.5rem;
    width:19.5rem;
    background-color: rgba(255,255,255,.15);
    transform: rotate(-30deg);
  }
  .voucher_bd .par{
    background: #D24161;
    float: left;
    padding:0.5rem 0.25rem;
    width: 60%;
    height:100%;
    box-sizing:border-box;
    border-right:0.1rem dashed rgba(255,255,255,.3);
    text-align: left;
  }
  .voucher_bd .par .top{
    text-align: center;
  }
  .voucher_bd .par p{
    text-align: center;
    color:#fff;
    font-size:0.8rem;
    margin-top:0.4rem;
  }
  .voucher_bd .par span{
    font-size:2.4rem;
    color:#fff;
    margin-right:0.25rem;
  }
  .voucher_bd .par .sign{
    font-size:1rem;
  }
  .voucher_bd .par sub{
    position: relative;
    top:-0.25rem;
    color:rgba(255,255,255,.8);
  }
  .voucher_bd .copy{
    display: inline-block;
    height:100%;
    padding:.5rem 0.7rem 0;
    width:40%;
    box-sizing:border-box;
    vertical-align: text-bottom;
    font-size:0.8rem;
    color:rgb(255,255,255);
    background: #D24161;
  }
  .voucher_bd .copy p{
    font-size:0.6rem;
    margin-top:0.35rem;
    white-space: nowrap;
  }
  .voucher_bd .copy a{
    display: block;
    height: 1.4rem;
    line-height: 1.4rem;
    /*background: #f00;*/
    margin-top: 0.7rem;
    border-radius: 5px;
    border: 1px solid #fff;
    text-align: center;
    color: #fff;
  }
  .voucher_bd02{
    background: #D24161;
    background: radial-gradient(transparent 0, transparent 0.25rem, #D24161 0.25rem);
    background-size:0.765rem 0.75rem;
    background-position:0.45rem 0.15rem;
  }
  .voucher_bd02:before{
    background-color:#D24161;
  }
  .voucher_bd.disable{
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;opacity: .5;
  }

</style>
